import { PayloadAction } from "@reduxjs/toolkit";
import { AlertHelper } from "helpers";
import { EAlertType } from "helpers/alertHelper";
import {
  ICreateCompanyRequest,
  ICreateCompanyResponse,
  IDeleteByIdRequest,
  IDeleteCompanyResponse,
  IUpdateCompanyRequest,
  IUpdateCompanyResponse,
} from "model";
import { IErrorResponse } from "model/Common/IErrorResponse";
import { call, put, takeEvery } from "redux-saga/effects";
import { CompanyActions } from "redux/actions";
import { CompanyApiService } from "services";

function* createCompany(action: PayloadAction<ICreateCompanyRequest>) {
  try {
    const result: ICreateCompanyResponse = yield call(
      CompanyApiService.createCompany,
      action.payload
    );
    if (result.succeeded) {
      yield put(CompanyActions.createCompany.success(result.data!));
      AlertHelper.showAlert("Create Successfully", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(CompanyActions.createCompany.failed(error));
    }
  } catch (error) {
    yield put(CompanyActions.createCompany.failed(error));
  }
}

function* updateCompany(action: PayloadAction<IUpdateCompanyRequest>) {
  try {
    const result: IUpdateCompanyResponse = yield call(
      CompanyApiService.updateCompany,
      action.payload
    );
    if (result.succeeded) {
      yield put(CompanyActions.updateCompany.success(result.data!));
      AlertHelper.showAlert("Update Successfully", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(CompanyActions.updateCompany.failed(error));
    }
  } catch (error) {
    yield put(CompanyActions.updateCompany.failed(error));
  }
}
function* deleteCompany(action: PayloadAction<IDeleteByIdRequest>) {
  try {
    const result: IDeleteCompanyResponse = yield call(
      CompanyApiService.deleteCompany,
      action.payload
    );
    if (result.succeeded) {
      yield put(CompanyActions.deleteCompany.success(result.data!));
      AlertHelper.showAlert("Delete Successfully", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(CompanyActions.deleteCompany.failed(error));
    }
  } catch (error) {
    yield put(CompanyActions.deleteCompany.failed(error));
  }
}

export function* Watcher() {
  yield takeEvery(CompanyActions.createCompany.request, createCompany);
  yield takeEvery(CompanyActions.updateCompany.request, updateCompany);
  yield takeEvery(CompanyActions.deleteCompany.request, deleteCompany);
}
